module.exports = __webpack_public_path__ + "img/segunda.b2d59cac.jpg";